import { render, staticRenderFns } from "./topSection.vue?vue&type=template&id=99d6f27a&scoped=true&"
import script from "./topSection.vue?vue&type=script&lang=js&"
export * from "./topSection.vue?vue&type=script&lang=js&"
import style0 from "./topSection.vue?vue&type=style&index=0&id=99d6f27a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d6f27a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99d6f27a')) {
      api.createRecord('99d6f27a', component.options)
    } else {
      api.reload('99d6f27a', component.options)
    }
    module.hot.accept("./topSection.vue?vue&type=template&id=99d6f27a&scoped=true&", function () {
      api.rerender('99d6f27a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/patrolTemplate/comComponents/topSection.vue"
export default component.exports